/** @format */

import {validateOrderWithErrors} from 'frontier/ds/quoter/functions/validate';
import {Modal, ModalHeader, ModalFooter, Toast} from '@sttark/design-system';
import {useSave} from 'frontier/components/form/use_save';
import {Input, Button} from '@sttark/design-system';
import {useForm} from 'frontier-form';
import {If} from 'frontier-utilities';
import React, {useState} from 'react';

export const EmailQuoteModal = props => {
    const {order} = props;

    const [success, setSuccess] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const {formData, setFormData} = useForm({email: '', name});

    const {save, isSaving, error} = useSave('/orders/email-order-details/' + order.id);

    async function handleSubmit(e) {
        e.preventDefault();
        setSuccess(false);

        try {
            const response = await save(formData);

            if (response.body?.success) {
                setSuccess(true);
                handleCloseModal();
            } else {
                setSuccess(false);
            }
        } catch (err) {
            console.error(err);
            setSuccess(false);
        }
    }

    function handleCloseModal() {
        setFormData({email: '', name: ''});
        setIsOpen(false);
    }

    const {isComplete} = validateOrderWithErrors(order);

    if (!isComplete) return null;

    return (
        <>
            <Toast
                onClose={() => setSuccess(false)}
                autoHideDuration={4000}
                isOpen={success}
                zIndex={3001}
                autoHide>
                <p className="m-0 p-0 color-structure-white">Email sent successfully!</p>
            </Toast>
            <Modal isOpen={isOpen} onClose={handleCloseModal} bodyHeightAuto>
                <ModalHeader onClose={handleCloseModal}>Print & Share</ModalHeader>
                <p className="quoter-form-modal-text mt-0 mb-4 mx-0">
                    Enter the email address you would like to send the quote to and your name.
                </p>
                <form onSubmit={handleSubmit} className="quoter-form-modal-form">
                    <Input
                        placeholder="Enter email to send to"
                        onChange={val => setFormData({...formData, email: val})}
                        label="Destination Email"
                        value={formData.email}
                        type="email"
                        name="email"
                    />
                    <Input
                        onChange={val => setFormData({...formData, name: val})}
                        placeholder="Enter your name"
                        label="Your Name"
                        value={formData.name}
                        type="text"
                        name="name"
                    />
                    <If condition={error}>
                        <p className="color-alert-negative m-0 p-0">{error}</p>
                    </If>
                </form>
                <ModalFooter>
                    <div className="d-flex align-items-center justify-content-between">
                        <a
                            className="color-accent-primary d-flex align-items-center justify-content-start m-0 p-0 gap-2"
                            href={'/orders/print-order-quote/' + order.id}
                            target="_blank">
                            <i className="fa fa-print" />
                            <u>Print Instead</u>
                        </a>
                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <Button onClick={handleCloseModal} label="Cancel" secondary small />
                            <Button
                                label={isSaving ? 'Send...' : 'Send'}
                                onClick={handleSubmit}
                                disabled={isSaving}
                                primary
                                small
                            />
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
            <button
                className="p-0 mx-0 mt-0 mb-2 color-accent-primary d-flex align-items-center justify-content-center gap-2"
                onClick={() => setIsOpen(true)}>
                <i className="fas fa-envelope" />
                <u>Print & Share</u>
            </button>
        </>
    );
};
